import { Component, OnInit, ViewEncapsulation } from '@angular/core';
// import { Helpers } from '../../../helpers';
// import { ScriptLoaderService } from '../../../_services/script-loader.service';
declare let toastr: any;

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body",
    templateUrl: "./default.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class DefaultComponent implements OnInit {
    constructor() {

    }

    ngOnInit() {
        toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": true,
            "progressBar": false,
            "positionClass": "toast-bottom-left",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/default.component.ts